import { ChartContainer } from './ChartContainer';
import { Smartphone, Monitor, Tablet } from 'lucide-react';

const deviceIcons = {
  Mobile: Smartphone,
  Desktop: Monitor,
  Tablet: Tablet
};

export const DeviceChart = ({ data }) => {
  return (
    <ChartContainer 
      title="Device Breakdown" 
      subtitle="How visitors access the site"
    >
      <div className="grid grid-cols-3 gap-4" data-testid="device-chart">
        {data.map((item, index) => {
          const Icon = deviceIcons[item.device];
          const isMain = index === 0;
          
          return (
            <div 
              key={index}
              className={`text-center p-4 rounded-xl transition-all duration-200 ${
                isMain 
                  ? 'bg-primary/10 border border-primary/20' 
                  : 'bg-secondary/50 hover:bg-secondary'
              }`}
            >
              <Icon className={`w-6 h-6 mx-auto mb-2 ${isMain ? 'text-primary' : 'text-muted-foreground'}`} />
              <div className={`text-2xl font-manrope font-bold ${isMain ? 'text-primary' : 'text-foreground'}`}>
                {item.percentage}%
              </div>
              <div className="text-xs text-muted-foreground mt-1 font-manrope">
                {item.device}
              </div>
              <div className="text-xs text-muted-foreground/70 font-manrope">
                {item.visitors.toLocaleString()}
              </div>
            </div>
          );
        })}
      </div>
    </ChartContainer>
  );
};
